import { Pipe, PipeTransform } from '@angular/core';
import {
  SalesByPaymentTypeResponse,
  SalesByDinerTypeResponse
} from 'src/app/models/pos-manager.model';

export interface PaymentTypeDisplayItem {
  key: string;
  displayName: string;
  amount: number;
  count: number;
}

@Pipe({
  name: 'realtimeTypeDisplay'
})
export class RealtimeTypeDisplayPipe implements PipeTransform {
  transform(
    salesByType: SalesByPaymentTypeResponse | SalesByDinerTypeResponse,
    realTimeInfoTypeMap: Map<string, string>
  ): PaymentTypeDisplayItem[] {
    if (!salesByType || !realTimeInfoTypeMap) {
      return [];
    }

    return Array.from(realTimeInfoTypeMap.entries()).map(
      ([key, displayName]) => {
        const data = salesByType[key];
        return {
          key,
          displayName,
          amount: data?.total_sales_amount || 0,
          count: data?.total_sales_count || 0
        };
      }
    );
  }
}
